import React from "react";
import responsive from "../assets/responsive.webp";
import responsive640 from "../assets/responsive-640.webp";
import { whatsappUrl } from "./util/whatsappUrl";
import { trackWhatsapp } from "./util/analytics";

const Budget = () => {
  return (
    <div className="bg-pattern-gradient pt-12 xl:pb-32">
      <div className="text-white w-3/4 mx-auto">
        <div className="grid xl:grid-cols-[5fr_3fr] xl:items-center xl:pt-48 pt-24 pb-16">
          <div className="xl:col-start-2 xl:row-start-1 xl:self-end z-10">
            <h1 className="text-5xl xl:text-6xl font-semibold leading-[1.1] mb-8">
              Software <strong className="text-gradient">sob medida</strong> e automação para a sua empresa
            </h1>
          </div>

          <div className="xl:col-start-1 xl:row-start-1 xl:row-span-2 xl:self-center z-10 mb-8 xl:mb-0">
            <img
              src={responsive}
              srcSet={`${responsive640} 640w, ${responsive} 1024w`}
              sizes="(min-width: 1280px) 45vw, 75vw"
              alt="Sistema desenvolvido pela Hawx Soluções exibido em um monitor e em um celular, ao lado de uma caneca com a logo da Hawx."
              width="1024"
              height="576"
              fetchpriority="high"
              className="h-auto mr-auto"
            />
          </div>

          <div className="xl:col-start-2 xl:row-start-2 xl:self-start z-10">
            <p className="text-xl xl:text-2xl leading-relaxed mb-10">
              Entendemos o seu problema, automatizamos processos e eliminamos gargalos com sistemas feitos para a sua operação.
            </p>
            <a
              href={whatsappUrl("Olá! Vi o site da Hawx e quero conversar sobre um projeto.")}
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => trackWhatsapp("hero")}
              className="btn-glass font-semibold py-6 px-8 rounded-full w-full xl:w-auto xl:min-w-[66.666%] whitespace-nowrap block xl:inline-block text-xl text-center"
            >
              Falar no WhatsApp
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Budget;
